module.exports = __webpack_public_path__ + "img/status-warning.6eca2ca3.svg";